import { Form, Modal } from "react-bootstrap";
import style from "./ModalPrint.module.css";

function ModalPrint({
  close,
  set,
  print: { needPrint, setNeedPrint },
  sms: { needSMS, setNeedSMS },
}) {
  return (
    <Modal show={true} centered={true} className={style.modal}>
      <Modal.Header>
        <h5>تعیین جزئیات سفارش</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-item-center pe-3">
          <input
            type="checkbox"
            id="4TalfS552"
            name="collecting"
            checked={needPrint}
            className="c-pointer"
            onChange={e => setNeedPrint(() => e.target.checked)}
          />
          <Form.Label
            htmlFor="4TalfS552"
            className="d-inline-block mx-2 my-0 c-pointer user-select-none"
          >
            نیاز به پرینت فاکتور برای مرسوله ها دارم
          </Form.Label>
        </div>

        <div className="d-flex align-item-center pe-3 mt-2">
          <input
            type="checkbox"
            id="yekjijbcfmlk"
            name="collecting"
            checked={needSMS}
            className="c-pointer"
            onChange={e => setNeedSMS(() => e.target.checked)}
          />
          <Form.Label
            htmlFor="yekjijbcfmlk"
            className="d-inline-block mx-2 my-0 c-pointer user-select-none"
          >
            نیاز به ارسال پیامک در مراحل ارسال دارم
          </Form.Label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-success"
          onClick={() => {
            set();
            close();
          }}
        >
          تایید
        </button>
        <button className="btn btn-danger" onClick={close}>
          بستن
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalPrint;
